(() => {
  // app/scripts/common/scrollTo.js
  function scrollTo(selector) {
    const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: "smooth"
    });
  }

  // app/scripts/common/bundleComponent.js
  window.customElements.define("bundle-component", class extends HTMLElement {
    connectedCallback() { 
      this.unavailable = this.querySelector('input[data-available="false"]');
    }
    submit() {
      const sections = ["mini-cart"];
      const items = [...this.querySelectorAll('input[name="bundle"]')].map((item) => {
        return { id: item.value };
      });
      return new Promise((resolve, reject) => {
        fetch(`${this.dataset.url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items, sections })
        }).then((e) => e.json()).then((result) => {
          resolve(result);
        });
      });
    }
  });

  // app/scripts/theme-custom.js
  document.body.addEventListener("click", (e) => {
    const { target } = e;
    if (target.closest(".jsScrollTo")) {
      e.preventDefault();
      scrollTo(target.closest(".jsScrollTo").href.split("#scrollTo")[1]);
    }
  });
})();
